<nav class="lib-nav">
  <h6>Files</h6>
  <div class="lib-badge">
    <span>{{files?.length}}</span>
  </div>
</nav>
<ul>
  <li *ngFor="let file of files">
    <lib-button prefixIcon="document" [disabled]="working" (buttonClick)="viewFile(file)">
        {{file.fileName}}
        <i class="lib-legend">{{(file.createdAt | date) || null}}</i>
    </lib-button>
  </li>
</ul>